import axios from "axios";

axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFToken";

const api = axios.create({
  baseURL: process.env.VUE_APP_DRF_API_URL,
  timeout: 5000,
  headers: {
    "Content-Type": "application/json"
  }
});

export default api;
